import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as t } from "../../chunks/tslib.es6.js";
import "../../geometry.js";
import { result as e } from "../../core/asyncUtils.js";
import i from "../../core/Collection.js";
import { HandleOwner as r } from "../../core/HandleOwner.js";
import { on as s, whenTrue as o } from "../../core/watchUtils.js";
import { property as n } from "../../core/accessorSupport/decorators/property.js";
import "../../core/arrayUtils.js";
import "../../core/has.js";
import "../../core/accessorSupport/ensureType.js";
import { subclass as a } from "../../core/accessorSupport/decorators/subclass.js";
import { extentContainsPoint as c } from "../../geometry/support/contains.js";
import { geographicToWebMercator as h, project as u } from "../../geometry/support/webMercatorUtils.js";
import l from "../../geometry/SpatialReference.js";

function p(t, e) {
  return t && "copyright" in t && (!e || "function" == typeof t.originOf && "user" === t.originOf("copyright"));
}

function d(t, e) {
  return t.length !== e.length || t.some(function (t, i) {
    return t.text !== e[i].text;
  });
}

function m(t, e, i) {
  if (!i || !e) return;
  t.find(function (t) {
    return t.layerView === e && t.text === i;
  }) || t.push({
    text: i,
    layerView: e
  });
}

function f(t) {
  return "bing-maps" === t.type;
}

var b = [];

var y = /*#__PURE__*/function (_r) {
  _inherits(y, _r);

  var _super = _createSuper(y);

  function y(t) {
    var _this;

    _classCallCheck(this, y);

    _this = _super.call(this, t), _this.clear = function () {
      _this._fetchedAttributionData.clear(), _this._pendingAttributions.clear(), _this.handles.remove("suspension"), _this.notifyChange("state");
    }, _this._pendingAttributions = new Set(), _this._fetchedAttributionData = new Map(), _this.items = new i(), _this.view = null, _this._allLayerViewsChange = function (t) {
      _this.handles.remove("suspension");

      var e = _this.get("view.allLayerViews");

      e && _this.handles.add(e.map(function (t) {
        return t.watch(["suspended", "attributionVisible"], _this._updateAttributionItems);
      }), "suspension"), t && t.removed && t.removed.forEach(function (t) {
        _this._pendingAttributions.delete(t), _this._fetchedAttributionData.delete(t);
      }), _this._updateAttributionItems();
    }, _this._updateAttributionItems = function () {
      var t = _this.get("view.allLayerViews");

      b.length = 0, t ? (t.forEach(function (t) {
        if (t.suspended || !t.get("layer.attributionVisible")) return;
        var e = t.layer;
        if (p(e, "user")) return void m(b, t, e.copyright);

        if (e.hasAttributionData) {
          if (_this._fetchedAttributionData.has(t)) {
            var _i = _this._fetchedAttributionData.get(t);

            return void (_i ? m(b, t, _this._getDynamicAttribution(_i, _this.view, e)) : p(e) && m(b, t, e.copyright));
          }

          return void _this._fetchAttributionData(t);
        }

        var i = e.get("portalItem.accessInformation");
        m(b, t, i || e.copyright);
      }), d(_this.items, b) && (_this.items.removeAll(), _this.items.addMany(b)), b.length = 0, _this.notifyChange("state")) : _this.clear();
    }, _this.handles.add([s(_assertThisInitialized(_this), "view.allLayerViews", "change", _this._allLayerViewsChange, _this._allLayerViewsChange, _this.clear), o(_assertThisInitialized(_this), "view.stationary", function () {
      return _this._updateAttributionItems();
    })]);
    return _this;
  }

  _createClass(y, [{
    key: "destroy",
    value: function destroy() {
      this.view = null, this._fetchedAttributionData.clear(), this._pendingAttributions.clear(), this.items.removeAll();
    }
  }, {
    key: "state",
    get: function get() {
      return this.get("view.ready") ? this._pendingAttributions.size > 0 ? "loading" : "ready" : "disabled";
    }
  }, {
    key: "_fetchAttributionData",
    value: function () {
      var _fetchAttributionData2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(t) {
        var i, _e;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this._pendingAttributions.has(t)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                this._pendingAttributions.add(t);

                _context.next = 5;
                return e(t.layer.fetchAttributionData());

              case 5:
                i = _context.sent;

                if (this._pendingAttributions.has(t)) {
                  _e = i.ok ? this._createContributionIndex(i.value, f(t.layer)) : null;
                  this._pendingAttributions.delete(t), this._fetchedAttributionData.set(t, _e);
                }

                this._updateAttributionItems();

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function _fetchAttributionData(_x) {
        return _fetchAttributionData2.apply(this, arguments);
      }

      return _fetchAttributionData;
    }()
  }, {
    key: "_createContributionIndex",
    value: function _createContributionIndex(t, e) {
      var i = t.contributors,
          r = {};
      if (!i) return r;

      for (var _s = 0; _s < i.length; _s++) {
        var _t = i[_s],
            _o = _t.coverageAreas;
        if (!_o) return;

        var _iterator = _createForOfIteratorHelper(_o),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _i2 = _step.value;

            var _o2 = _i2.bbox,
                _n = _i2.zoomMin - (e && _i2.zoomMin ? 1 : 0),
                _a = _i2.zoomMax - (e && _i2.zoomMax ? 1 : 0),
                _c = {
              xmin: _o2[1],
              ymin: _o2[0],
              xmax: _o2[3],
              ymax: _o2[2],
              spatialReference: l.WGS84
            },
                _u = {
              extent: h(_c),
              attribution: _t.attribution || "",
              score: null != _i2.score ? _i2.score : 100,
              id: _s
            };

            for (var _t2 = _n; _t2 <= _a; _t2++) {
              r[_t2] = r[_t2] || [], r[_t2].push(_u);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }

      return r.maxKey = Math.max.apply(null, Object.keys(r)), r;
    }
  }, {
    key: "_getDynamicAttribution",
    value: function _getDynamicAttribution(t, e, i) {
      var r = e.extent,
          s = e.scale;
      var o = i.tileInfo.scaleToZoom(s);
      if (o = Math.min(t.maxKey, Math.round(o)), !r || null == o || o <= -1) return "";
      var n = t[o],
          a = u(r.center.clone().normalize(), e.spatialReference),
          h = {};
      return n ? n.filter(function (t) {
        var e = !h[t.id] && a && c(t.extent, a);
        return e && (h[t.id] = !0), e;
      }).sort(function (t, e) {
        return e.score - t.score || t.objectId - e.objectId;
      }).map(function (t) {
        return t.attribution;
      }).join(", ") : "";
    }
  }]);

  return y;
}(r);

t([n({
  readOnly: !0,
  type: i
})], y.prototype, "items", void 0), t([n({
  readOnly: !0
})], y.prototype, "state", null), t([n()], y.prototype, "view", void 0), y = t([a("esri.widgets.Attribution.AttributionViewModel")], y);
var g = y;
export { g as default };